import io from 'socket.io-client'

class SocketService {
  constructor (url, secret) {
    this.url = url
    this.secret = secret || ''
    this.socket = null
    this.connected = false
    this.userId = null

    this._pendingListeners = []
    this._joinedRooms = {}
  }

  _attachPendingListeners () {
    if (!this.socket) return
    for (var i = 0; i < this._pendingListeners.length; i++) {
      var item = this._pendingListeners[i]
      this.socket.on(item.event, item.callback)
    }
    this._pendingListeners = []
  }

  _rejoinAllRooms () {
    var self = this
    if (!this.socket || !this.socket.connected) return

    Object.keys(this._joinedRooms).forEach(function (rid) {
      var token = self._joinedRooms[rid]

      var payload = { roomId: rid }
      if (token && token !== true) payload.token = token

      self.socket.emit('join-room', payload, function (resp) {
        if (!(resp && resp.ok === true)) {
          console.error('[Socket] Falha ao rejoin', rid, resp)
        }
      })
    })
  }

  connect (userId) {
    var self = this
    this.userId = userId

    if (this.socket) {
      try { this.socket.disconnect() } catch (e) {}
      this.socket = null
      this.connected = false
    }

    this.socket = io(this.url, {
      query: { userId: String(userId) },
      transports: ['websocket', 'polling'],
      reconnection: true,
      reconnectionDelay: 1000,
      reconnectionDelayMax: 5000,
      reconnectionAttempts: Infinity
    })

    this.socket.on('connect', function () {
      self.connected = true
      self._rejoinAllRooms()
    })

    this.socket.on('disconnect', function () {
      self.connected = false
    })

    this.socket.on('connect_error', function () {
      self.connected = false
    })

    this._attachPendingListeners()

    return this.socket
  }

  joinRoom (roomId, token) {
    if (!roomId) {
      console.warn('[Socket] joinRoom ignorado: roomId inválido', roomId)
      return
    }

    const rid = String(roomId)
    const nextToken = token || true
    const prevToken = this._joinedRooms[rid]

    // Se já está marcado como joined com o mesmo token e o socket está conectado,
    // não re-emite (evita múltiplas inscrições no servidor -> mensagens duplicadas)
    if (prevToken != null && String(prevToken) === String(nextToken) && this.socket && this.socket.connected) {
      return
    }

    this._joinedRooms[rid] = nextToken

    if (!this.socket) return

    const payload = { roomId: rid }
    if (nextToken && nextToken !== true) payload.token = nextToken

    this.socket.emit('join-room', payload, (resp) => {
      if (!(resp && resp.ok)) {
        console.error('[Socket] join fail', rid, resp)
      }
    })
  }

  on (event, callback) {
    if (this.socket) this.socket.on(event, callback)
    else this._pendingListeners.push({ event: event, callback: callback })
  }
}

export default SocketService



// WEBPACK FOOTER //
// ./src/plugins/chat-plugin/services/socket.js